module.exports = __webpack_public_path__ + "static/img/21_pro.87aaf3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/21_pro.jpg
// module id = wRDi
// module chunks = 0